import { AnnouncementType } from '@/app/enums/AnnouncementType';
import { formatDateTimeToString } from '@/app/helpers/formatDateTimeToString';
import { type AnnouncementRecipientDto } from '@/app/models/AnnouncementRecipientDto';

export const sortOldestFirst = (announcements: AnnouncementRecipientDto[]): AnnouncementRecipientDto[] =>
  [...announcements].sort((first, second) => first.start_date.localeCompare(second.start_date));

// O backend decide o que está pendente (publicado, dentro da vigência, sem ciência/dispensa).
export const isMandatory = (type: AnnouncementType): boolean => type === AnnouncementType.MANDATORY;

/** Só http e https: é a mesma regra com que o backend vincula a mídia do corpo ao comunicado. */
export const isAnnouncementMediaUrl = (source: string): boolean => {
  try {
    const url = new URL(source);
    return (url.protocol === 'http:' || url.protocol === 'https:') && !!url.hostname;
  } catch {
    return false;
  }
};

/** Quem publicou e quando; sem o nome, só a data, e sem a data (rascunho), só o nome. */
export const publishedLabel = (senderName?: string, publishedDate?: string): string => {
  if (!publishedDate) return senderName ?? '';
  const publishedDateLabel = formatDateTimeToString(publishedDate);
  if (!senderName) return publishedDateLabel;
  return `${senderName} · ${publishedDateLabel}`;
};

/** O valor do atributo, só quando a lista permitida o conhece; o HTML salvo pode trazer qualquer texto. */
export const readMediaAttribute = (element: HTMLElement, name: string, allowed: Set<string>): string | null => {
  const value = element.getAttribute(name);
  return value && allowed.has(value) ? value : null;
};
